module.exports = __webpack_public_path__ + "static/img/bg-one-glass.26dd64b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg-one-glass.png
// module id = 46
// module chunks = 0